import { Header } from "../../../../src/components/common/header";
import { UAECookiePolicyEn } from "../../../../src/components/cookie-policy/uae/en";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  Header,
  UAECookiePolicyEn,
  Footer,
  React
};